// src/FactDisplay.js

import React, { useState } from 'react';
import './FactDisplay.css';

const factsData = {
    Maths: {
      fact: "Did you know that zero is the only number that cannot be represented by Roman numerals?",
      explanation: ["Zero was invented by ancient Indian mathematicians.", "It plays a crucial role in the place value system."],
      importance: ["Zero is essential for arithmetic operations.", "It is the foundation of the binary system used in computers."]
    },
    Science: {
      fact: "Did you know that light travels at a speed of approximately 300,000 kilometers per second?",
      explanation: ["Light is a form of electromagnetic radiation.", "It can travel through a vacuum and various media."],
      importance: ["Light is essential for photosynthesis in plants.", "It enables us to see the world around us."]
    },
    EVS: {
      fact: "Did you know that the Amazon rainforest produces 20% of the world's oxygen?",
      explanation: ["The Amazon rainforest is known as the 'lungs of the Earth'.", "It is home to a diverse range of species."],
      importance: ["The Amazon rainforest helps regulate the Earth's climate.", "It provides habitat for countless species."]
    },
    English: {
      fact: "Did you know that the longest word in the English language is 45 letters long?",
      explanation: ["The word is 'pneumonoultramicroscopicsilicovolcanoconiosis'.", "It is a lung disease caused by inhaling fine silica dust."],
      importance: ["Understanding complex words can enhance vocabulary.", "It helps in effective communication and comprehension."]
    },
    Hindi: {
      fact: "Did you know that Hindi is the fourth most spoken language in the world?",
      explanation: ["Hindi is spoken by over 600 million people.", "It is one of the official languages of India."],
      importance: ["Hindi is a rich and expressive language.", "It plays a significant role in Indian culture and heritage."]
    },
    Telugu: {
      fact: "Did you know that Telugu is known as the 'Italian of the East'?",
      explanation: ["Telugu has a melodious and rhythmic sound.", "It is one of the classical languages of India."],
      importance: ["Telugu has a rich literary tradition.", "It is spoken by millions of people in India and abroad."]
    },
    History: {
      fact: "Did you know that the Great Wall of China is over 13,000 miles long?",
      explanation: ["The Great Wall was built over several centuries.", "It was constructed to protect Chinese states from invasions."],
      importance: ["The Great Wall is a symbol of China's strength and perseverance.", "It is one of the most remarkable architectural feats in history."]
    },
    Geography: {
      fact: "Did you know that Mount Everest is the highest mountain in the world?",
      explanation: ["Mount Everest's peak is 8,848 meters above sea level.", "It is located in the Himalayas on the border of Nepal and Tibet."],
      importance: ["Mount Everest is a significant challenge for climbers.", "It represents the ultimate test of human endurance and perseverance."]
    },
    Chemistry: {
      fact: "Did you know that water expands when it freezes?",
      explanation: ["Water molecules form a crystalline structure when frozen.", "This structure causes ice to occupy more space than liquid water."],
      importance: ["This property of water is essential for the survival of aquatic life in cold climates.", "It prevents water bodies from freezing solid from the bottom up."]
    },
    Physics: {
      fact: "Did you know that every object in the universe exerts gravitational force on every other object?",
      explanation: ["Gravitational force is a fundamental force of nature.", "It is described by Newton's law of universal gravitation."],
      importance: ["Gravitational force keeps planets in orbit around the sun.", "It plays a crucial role in the formation and structure of the universe."]
    },
    Biology: {
      fact: "Did you know that the human body contains approximately 37.2 trillion cells?",
      explanation: ["Cells are the basic building blocks of all living organisms.", "Different types of cells perform various functions in the body."],
      importance: ["Cells are essential for growth, development, and repair.", "They enable the body to carry out complex biological processes."]
    },
    Astronomy: {
      fact: "Did you know that a day on Venus is longer than a year on Venus?",
      explanation: ["Venus has a very slow rotation on its axis.", "It takes 243 Earth days to complete one rotation and 225 Earth days to orbit the sun."],
      importance: ["Understanding planetary rotations helps scientists study the dynamics of the solar system.", "It provides insights into the unique characteristics of planets."]
    },
    Literature: {
      fact: "Did you know that Shakespeare invented over 1,700 words?",
      explanation: ["Shakespeare's creativity significantly expanded the English language.", "Some of his coined words include 'bedazzled', 'swagger', and 'lonely'."],
      importance: ["Shakespeare's contributions enriched the English vocabulary.", "His works continue to influence literature and language studies."]
    },
    Technology: {
      fact: "Did you know that the first computer was invented in the 1940s?",
      explanation: ["The ENIAC (Electronic Numerical Integrator and Computer) was the first electronic general-purpose computer.", "It was developed by John Presper Eckert and John Mauchly."],
      importance: ["The invention of the computer revolutionized technology and society.", "It paved the way for modern computing and digital advancements."]
    },
    Art: {
      fact: "Did you know that the Mona Lisa has no eyebrows?",
      explanation: ["Leonardo da Vinci's famous painting, the Mona Lisa, lacks eyebrows.", "It is believed that the eyebrows were removed during early restorations."],
      importance: ["The Mona Lisa is one of the most renowned artworks in history.", "It represents the epitome of Renaissance art and creativity."]
    },
    Music: {
      fact: "Did you know that Beethoven composed some of his greatest works while completely deaf?",
      explanation: ["Ludwig van Beethoven lost his hearing in his late twenties.", "Despite his deafness, he continued to compose music and created masterpieces like the Ninth Symphony."],
      importance: ["Beethoven's resilience and determination are an inspiration to many.", "His music remains a testament to his genius and creativity."]
    },
    Sports: {
      fact: "Did you know that the Olympic Games originated in ancient Greece?",
      explanation: ["The first recorded Olympic Games took place in 776 BC in Olympia, Greece.", "They were held in honor of the Greek god Zeus."],
      importance: ["The Olympic Games promote unity and sportsmanship among nations.", "They celebrate athletic excellence and human potential."]
    },
    Environment: {
      fact: "Did you know that deforestation contributes to climate change?",
      explanation: ["Trees absorb carbon dioxide and release oxygen.", "Deforestation reduces the number of trees that can absorb greenhouse gases."],
      importance: ["Preserving forests is essential for mitigating climate change.", "Forests play a crucial role in maintaining ecological balance."]
    },
    Health: {
      fact: "Did you know that drinking water can improve cognitive function?",
      explanation: ["Water is essential for maintaining proper hydration.", "Staying hydrated helps improve concentration and mental clarity."],
      importance: ["Drinking enough water is vital for overall health and well-being.", "It supports various bodily functions, including brain function."]
    },

        Scientific: {
          fact: "Did you know that DNA was first discovered in the late 19th century?",
          explanation: ["DNA was discovered by Friedrich Miescher in 1869.", "He called it 'nuclein'."],
          importance: ["DNA is the blueprint of life, carrying genetic information.", "It is essential for heredity and the functioning of living organisms."]
        },
        Inventions: {
          fact: "Did you know that the first telephone was invented by Alexander Graham Bell in 1876?",
          explanation: ["Bell's invention revolutionized communication.", "The first words spoken on the telephone were 'Mr. Watson, come here, I want to see you.'"],
          importance: ["The telephone allowed instant communication over long distances.", "It paved the way for modern telecommunication technologies."]
        },
        Archaeology: {
          fact: "Did you know that the Rosetta Stone was key to deciphering Egyptian hieroglyphs?",
          explanation: ["The Rosetta Stone was discovered in 1799.", "It contains the same text in Greek, Demotic, and Egyptian hieroglyphs."],
          importance: ["The Rosetta Stone helped scholars understand ancient Egyptian writing.", "It unlocked the secrets of Egypt's ancient civilization."]
        },
        Research: {
          fact: "Did you know that the first successful organ transplant was performed in 1954?",
          explanation: ["The kidney transplant was performed by Dr. Joseph Murray.", "The recipient and donor were identical twins."],
          importance: ["Organ transplants have saved countless lives.", "They are a testament to the advancements in medical science."]
        },
        Mind: {
          fact: "Did you know that the human brain can generate about 23 watts of power?",
          explanation: ["The brain generates electrical activity through neurons.", "This power is enough to power a small light bulb."],
          importance: ["The brain's electrical activity is crucial for thought and function.", "It highlights the brain's incredible capacity and complexity."]
        },
        Space: {
          fact: "Did you know that one day on Venus is longer than one year on Earth?",
          explanation: ["Venus takes 243 Earth days to rotate once.", "It orbits the sun in about 225 Earth days."],
          importance: ["This unique fact helps us understand planetary rotations.", "It provides insight into the dynamics of our solar system."]
        },
        
        Evolution: {
          fact: "Did you know that birds are the closest living relatives of dinosaurs?",
          explanation: ["Birds evolved from theropod dinosaurs.", "Fossil evidence supports the link between birds and dinosaurs."],
          importance: ["Understanding this link provides insights into evolutionary biology.", "It helps scientists study the adaptations and evolution of species."]
        },
        Botany: {
          fact: "Did you know that the largest flower in the world is the Rafflesia arnoldii?",
          explanation: ["The flower can grow up to 3 feet in diameter.", "It emits a strong odor similar to rotting flesh."],
          importance: ["The Rafflesia arnoldii is a unique and rare plant.", "Studying it helps scientists understand plant diversity and ecology."]
        },
        Medicine: {
          fact: "Did you know that antibiotics were discovered by Alexander Fleming in 1928?",
          explanation: ["Fleming discovered penicillin from the mold Penicillium.", "It revolutionized the treatment of bacterial infections."],
          importance: ["Antibiotics have saved countless lives.", "They are crucial in combating bacterial infections and diseases."]
        },
        Psychology: {
          fact: "Did you know that the placebo effect can have real physiological outcomes?",
          explanation: ["The placebo effect occurs when a person experiences a benefit after receiving a placebo.", "The mind's belief in treatment can trigger real changes in the body."],
          importance: ["The placebo effect highlights the power of the mind.", "It is a significant factor in clinical trials and medical treatments."]
        },
        
            Genetics: {
              fact: "Did you know that humans share about 60% of their DNA with bananas?",
              explanation: ["DNA is the genetic material found in all living organisms.", "Humans and bananas share many basic biological functions."],
              importance: ["Studying genetic similarities helps scientists understand evolution.", "It provides insights into the common ancestry of life on Earth."]
            },
            Birds: {
              fact: "Did you know that hummingbirds can flap their wings up to 80 times per second?",
              explanation: ["Hummingbirds have highly specialized wing muscles.", "Their rapid wing flapping allows them to hover in mid-air."],
              importance: ["Hummingbirds play a vital role in pollination.", "They are fascinating examples of adaptation and evolution."]
            },
            French: {
              fact: "Did you know that French is one of the official languages of the United Nations?",
              explanation: ["French is spoken by over 275 million people worldwide.", "It is an official language in 29 countries."],
              importance: ["French is a major global language of diplomacy and culture.", "Learning French can enhance career opportunities and cultural understanding."]
            },
            Medicine: {
              fact: "Did you know that penicillin, the first antibiotic, was discovered by accident?",
              explanation: ["Penicillin was discovered by Alexander Fleming in 1928.", "He noticed that mold had killed bacteria in a petri dish."],
              importance: ["Penicillin revolutionized the treatment of bacterial infections.", "It has saved countless lives since its discovery."]
            },
            Sanskrit: {
              fact: "Did you know that Sanskrit is considered the mother of many Indo-European languages?",
              explanation: ["Sanskrit has a highly systematic grammar.", "It has influenced languages like Hindi, Bengali, and even English."],
              importance: ["Sanskrit is a key to understanding ancient texts and wisdom.", "It is a treasure trove of knowledge in various fields, including philosophy, science, and literature."]
            },
            School: {
              fact: "Did you know that the concept of compulsory education dates back to ancient Greece?",
              explanation: ["Ancient Greece emphasized the importance of educating all citizens.", "Education was considered essential for a functioning democracy."],
              importance: ["Compulsory education ensures that every child has access to basic knowledge and skills.", "It lays the foundation for personal and societal growth."]
            },
            College: {
              fact: "Did you know that the University of Bologna, founded in 1088, is considered the oldest university in the world?",
              explanation: ["The University of Bologna is located in Italy.", "It has been a center of learning and scholarship for centuries."],
              importance: ["Universities play a crucial role in advancing knowledge and research.", "They provide opportunities for higher education and intellectual growth."]
            },
            Kids: {
              fact: "Did you know that play is essential for a child's development?",
              explanation: ["Play helps children develop physical, cognitive, and social skills.", "It encourages creativity and problem-solving."],
              importance: ["Play is crucial for healthy brain development.", "It provides opportunities for learning and building relationships."]
            },
            Family: {
              fact: "Did you know that family meals can positively impact children's well-being?",
              explanation: ["Family meals provide opportunities for communication and bonding.", "They help establish healthy eating habits."],
              importance: ["Regular family meals are associated with better academic performance and emotional health.", "They strengthen family connections and support systems."]
            },
            Archaeology: {
              fact: "Did you know that the Rosetta Stone was key to deciphering Egyptian hieroglyphs?",
              explanation: ["The Rosetta Stone is an ancient Egyptian stele inscribed with text in three scripts.", "It helped linguists understand and translate hieroglyphs."],
              importance: ["The Rosetta Stone unlocked the secrets of ancient Egyptian writing.", "It provided valuable insights into ancient Egyptian civilization."]
            },
            Research: {
              fact: "Did you know that the scientific method is a systematic way of investigating phenomena?",
              explanation: ["The scientific method involves making observations, forming hypotheses, conducting experiments, and drawing conclusions.", "It is a rigorous approach to acquiring knowledge."],
              importance: ["The scientific method ensures the reliability and validity of research findings.", "It helps scientists develop theories and advance our understanding of the world."]
            },
            Evolution: {
              fact: "Did you know that birds are the closest living relatives of dinosaurs?",
              explanation: ["Birds evolved from theropod dinosaurs.", "Fossil evidence supports the link between birds and dinosaurs."],
              importance: ["Understanding this link provides insights into evolutionary biology.", "It helps scientists study the adaptations and evolution of species."]
            },
            ModernCivilization: {
              fact: "Did you know that the internet has revolutionized modern communication?",
              explanation: ["The internet enables instant communication worldwide.", "It has transformed various aspects of society, including education, business, and entertainment."],
              importance: ["The internet plays a crucial role in modern life.", "It facilitates the exchange of information and connects people globally."]
            },
          
          
  };
  

const FactDisplay = () => {
  const [selectedSubject, setSelectedSubject] = useState('Maths');

  const handleReadAloud = () => {
    const subjectFact = factsData[selectedSubject];
    const utterance = new SpeechSynthesisUtterance(subjectFact.fact);
    speechSynthesis.speak(utterance);

    subjectFact.explanation.forEach((step) => {
      const stepUtterance = new SpeechSynthesisUtterance(step);
      speechSynthesis.speak(stepUtterance);
    });

    const importanceUtterance = new SpeechSynthesisUtterance(subjectFact.importance.join(' '));
    speechSynthesis.speak(importanceUtterance);
  };

  const handleSubjectChange = (e) => {
    setSelectedSubject(e.target.value);
  };

  const currentFact = factsData[selectedSubject];

  return (
    <div className="fact-display">
      <h1>Interesting Facts</h1>
      

      <div className="subject-select">
        <label>Select Subject: </label>
        <select value={selectedSubject} onChange={handleSubjectChange}>
          {Object.keys(factsData).map((subject) => (
            <option key={subject} value={subject}>{subject}</option>
          ))}
        </select>
      </div>
      <div className="fact">
        <p>{currentFact.fact}</p>
      </div>
      <div className="explanation">
        <h2>Explanation:</h2>
        <ul>
          {currentFact.explanation.map((step, index) => (
            <li key={index}>{step}</li>
          ))}
        </ul>
        <h2>Importance:</h2>
        <p>{currentFact.importance.join(' ')}</p>
      </div>
      <div className="buttons">
        <button onClick={handleReadAloud}>Read Aloud</button>
      </div>
    </div>
  );
};

export default FactDisplay;
